import * as lib from '~/dependencies';

export const BoxDev = lib.styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  label {
    margin-left: 0px;
  }
`;
